import { render } from "./SmallHeroItem.vue?vue&type=template&id=64953b9a&scoped=true"
import script from "./SmallHeroItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallHeroItem.vue?vue&type=script&setup=true&lang=js"

import "./SmallHeroItem.vue?vue&type=style&index=0&id=64953b9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64953b9a"],['__file',"src/components/Paragraphs/SmallHeroItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64953b9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64953b9a', __exports__)) {
    api.reload('64953b9a', __exports__)
  }
  
  module.hot.accept("./SmallHeroItem.vue?vue&type=template&id=64953b9a&scoped=true", () => {
    api.rerender('64953b9a', render)
  })

}


export default __exports__